import { useEffect, useState } from "react";
import {
  AutocompleteInput,
  ReferenceInput,
  useDataProvider,
} from "react-admin";
import { useField } from "react-final-form";

interface IRouteInput {
  isDisable?: boolean;
}

const RouteInput = ({ isDisable }: IRouteInput) => {
  const [busSchedulePlan, setBusSchedulePlan] = useState<any>();

  const provider = useDataProvider();
  const {
    input: { value },
  } = useField("busScheduleId");

  const studentInput = useField("studentId");
  const levelInput = useField("levelId");

  useEffect(() => {
    if (value !== "") {
      getBusSchedulePlans(value).then((result) => {
        setBusSchedulePlan(result);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  const getBusSchedulePlans = async (busScheduleId: Number) => {
    return await provider
      .getList("busSchedulePlans", {
        filter: { BusScheduleId: busScheduleId },
        pagination: {
          page: 1,
          perPage: 1000,
        },
        sort: {
          field: "Id",
          order: "ASC",
        },
      })
      .then((result) => {
        return result.data[0];
      });
  };

  return (
    <ReferenceInput
      label="Select Route"
      source="routeId"
      reference="routes"
      filter={{
        RoutePlanId: busSchedulePlan
          ? Number(busSchedulePlan.routePlan?.id)
          : 0,
      }}
      sort={{ field: "name", order: "ASC" }}
      onChange={() => {
        studentInput.input.onChange("");
        levelInput.input.onChange("");
      }}
      disabled={isDisable}
      perPage={9999}
    >
      <AutocompleteInput optionText="name" />
    </ReferenceInput>
  );
};

export default RouteInput;
